import QuestionsStore from "./QuestionsStore";
import TestsStore from "./TestsStore";
import MainAppStore from "./MainAppStore";
import { makeAutoObservable } from "mobx";

export class RootStore {
  questionsStore: QuestionsStore;
  testStore: TestsStore;
  mainAppStore: MainAppStore;

  constructor() {
    makeAutoObservable(this);

    this.questionsStore = new QuestionsStore(this);
    this.testStore = new TestsStore(this);
    this.mainAppStore = new MainAppStore(this);
  }

  async reset() {
    await this.questionsStore.reset();
    await this.testStore.reset();
    await this.mainAppStore.reset();
    return;
  }
}

const RootStoreInstance = new RootStore();

export const useRootStore = () => {
  return RootStoreInstance;
};

export default RootStoreInstance;
